export const AudienceType = {
  GET_AUDIENCE_DATA: "GET_AUDIENCE_DATA",
  SET_EXPAND_VIEW: "SET_EXPAND_VIEW",
  CLEAR_AUDIENCE_DATA: "CLEAR_AUDIENCE_DATA",
};
